import userAccountListFixture from '../queryCapabilities/fixtures/user-account-list.json';
import { loadQueryCapabilityFixture } from '../queryCapabilities/queryCapabilities';

export const userAccountListQueryCapabilities = loadQueryCapabilityFixture(userAccountListFixture);

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;

const sanitizeFinitePageSize = (value: number): number | null =>
  Number.isFinite(value) && Number.isInteger(value) ? value : null;

const clampUserAccountPageSize = (value: number): number => {
  const { minimum, maximum } = userAccountListQueryCapabilities.pagination.pageSize;

  return Math.min(Math.max(value, minimum), maximum);
};

export const getDefaultUserAccountPageSize = (candidate?: number): number => {
  const fallback = userAccountListQueryCapabilities.pagination.pageSize.default;
  const sanitizedCandidate = candidate === undefined ? null : sanitizeFinitePageSize(candidate);

  return clampUserAccountPageSize(sanitizedCandidate ?? fallback);
};

export const getUserAccountPageSizeOptions = (candidateOptions?: number[]): number[] => {
  const { minimum, maximum } = userAccountListQueryCapabilities.pagination.pageSize;
  const source = candidateOptions?.length ? candidateOptions : [...DEFAULT_PAGE_SIZE_OPTIONS];
  const options = new Set<number>();

  for (const option of source) {
    const sanitizedOption = sanitizeFinitePageSize(option);
    if (sanitizedOption === null) {
      continue;
    }
    if (sanitizedOption < minimum || sanitizedOption > maximum) {
      continue;
    }
    options.add(sanitizedOption);
  }

  options.add(getDefaultUserAccountPageSize());

  return [...options].sort((left, right) => left - right);
};
